import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Line } from 'recharts';

// Example placeholder data
const data = [
  { month: 'Jan', value: 20, avg: 10 },
  { month: 'Feb', value: 50, avg: 30 },
  { month: 'Mar', value: 80, avg: 40 },
  { month: 'Apr', value: 200, avg: 100 },
  { month: 'May', value: 500, avg: 200 },
  { month: 'Jun', value: 300, avg: 250 },
  { month: 'Jul', value: 400, avg: 300 },
  { month: 'Aug', value: 250, avg: 350 },
  { month: 'Sep', value: 500, avg: 400 },
];

const periodOptions = [
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'year', label: 'Year' },
  { value: 'all', label: 'All Time' }
];

export default function AttendanceAnalyticsChart({
  chartData = data,
  attendanceChange = 5,
  periodLabel = 'this year',
  selectedPeriod = 'year',
  onPeriodChange = () => {},
}) {
  const isPositive = attendanceChange > 0;
  const isNegative = attendanceChange < 0;
  const changeText = isPositive
    ? `${attendanceChange}% more present`
    : isNegative
      ? `${Math.abs(attendanceChange)}% less present`
      : 'No change';
  const changeColor = isPositive
    ? 'text-green-600'
    : isNegative
      ? 'text-red-500'
      : 'text-slate-400';

  return (
    <div className="bg-white rounded-xl shadow p-6 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2">
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-lg text-slate-800">Attendance Overview</span>
          <span className={`${changeColor} font-medium text-sm`}>
            {changeText} <span className="text-slate-400 font-normal">{periodLabel}</span>
          </span>
        </div>
        <div>
          <select
            className="border border-slate-200 rounded-lg px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            value={selectedPeriod}
            onChange={e => onPeriodChange(e.target.value)}
          >
            {periodOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#2563eb" stopOpacity={0.25}/>
              <stop offset="95%" stopColor="#2563eb" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid vertical={false} strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fill: '#94a3b8', fontSize: 13 }} padding={{ left: 10, right: 10 }} />
          <YAxis axisLine={false} tickLine={false} tick={{ fill: '#cbd5e1', fontSize: 12 }} domain={[0, 600]} />
          <Tooltip contentStyle={{ borderRadius: 12, border: 'none', boxShadow: '0 2px 8px #0001' }} labelStyle={{ color: '#64748b' }} />
          <Area type="monotone" dataKey="value" stroke="#2563eb" strokeWidth={3} fillOpacity={1} fill="url(#colorValue)" />
          <Line type="monotone" dataKey="avg" stroke="#22292f" strokeWidth={4} dot={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
} 